var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg072Refresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 21C14.2136 21.0005 16.3497 20.1852 18.0001 18.71C18.3778 18.3355 18.3962 17.7308 18.042 17.334C17.6878 16.9372 17.0849 16.8871 16.6701 17.22C14.3598 19.2966 10.9572 19.6023 8.31385 17.9706C5.67044 16.3389 4.41858 13.1604 5.23941 10.1643C6.06023 7.16832 8.75738 5.07164 11.8633 5.01514C14.9692 4.95864 17.7408 6.95582 18.6701 9.92L17.5401 9.17C17.0851 8.92592 16.519 9.06841 16.2338 9.49885C15.9486 9.92928 16.038 10.5061 16.4401 10.83L19.4401 12.83C19.8487 13.0958 20.3894 13.0282 20.7201 12.67C20.7587 12.6347 20.7923 12.5943 20.8201 12.55L22.8201 9.55C23.0581 9.25447 23.1084 8.84967 22.9498 8.50489C22.7913 8.16012 22.4513 7.9348 22.072 7.92317C21.6927 7.91153 21.3395 8.11559 21.1601 8.45L20.5801 9.31C19.1993 4.90151 14.705 2.25434 10.1799 3.18421C5.6548 4.11408 2.56857 8.31899 3.03809 12.9147C3.50762 17.5105 7.38042 21.0044 12.0001 21Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg072Refresh);
export default __webpack_public_path__ + "static/media/072-refresh.89c9f25bafa9f69e09b41393c434547a.svg";
export { ForwardRef as ReactComponent };